import { render, staticRenderFns } from "./douyin.vue?vue&type=template&id=3e0ec022"
import script from "./douyin.vue?vue&type=script&lang=js"
export * from "./douyin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports